import { useRouter } from "next/router"
import { useEffect } from "react"

export function useDBStatus(dbStatus: string, dbSource?: string) {
  const router = useRouter()
  const routerStatus = router.query.status
  const routerSource = router.query.source

  useEffect(() => {
    if (!dbStatus) {
      return
    }
    const statusMatches = dbStatus === routerStatus
    const sourceMatches = dbSource === undefined || routerSource === dbSource
    if (statusMatches && sourceMatches) {
      return
    }
    router.replace(
      {
        pathname: router.pathname,
        query: {
          ...router.query,
          status: dbStatus,
          ...(dbSource && { source: dbSource }),
        },
      },
      undefined,
      { shallow: true }
    )
  }, [dbStatus, dbSource, routerStatus, routerSource, router])
}
